// The reveal half of lib/devMode.ts. Deliberately not a labelled button — it's a small,
// unlabelled dot dropped next to the recorder topbar's back control, tapped several times in
// quick succession (Android build-number style) to flip developer mode on or off. Invisible to
// assistive tech (aria-hidden, unreachable by keyboard) since it isn't part of the accessible
// UI surface, just a memorable back door for whoever already knows it's there.
import { useRef, useState } from "react";
import { toggleDevMode } from "../lib/devMode";

const TAPS_TO_UNLOCK = 7;
const TAP_WINDOW_MS = 3000;

export default function DevModeUnlock() {
  const taps = useRef<number[]>([]);
  const [flash, setFlash] = useState<string | null>(null);

  const onTap = () => {
    const now = performance.now();
    taps.current = [...taps.current.filter((t) => now - t < TAP_WINDOW_MS), now];
    if (taps.current.length < TAPS_TO_UNLOCK) return;
    taps.current = [];
    const on = toggleDevMode();
    setFlash(on ? "Developer mode on" : "Developer mode off");
    window.setTimeout(() => setFlash(null), 2000);
  };

  return (
    <span className="dev-unlock">
      <button type="button" className="dev-unlock-dot" aria-hidden tabIndex={-1} onClick={onTap} />
      {flash ? <span className="dev-unlock-flash mono">{flash}</span> : null}
    </span>
  );
}
